import imageOne from '../../images/image-gallery-1.jpg';
import imageTwo from '../../images/image-gallery-2.jpg';
import imageThree from '../../images/image-gallery-3.jpg';
import imageFour from '../../images/image-gallery-4.jpg';
import imageFive from '../../images/image-gallery-5.jpg';
import imageSix from '../../images/image-gallery-6.jpg';
import imageSeven from '../../images/image-gallery-7.jpg';
import imageEight from '../../images/image-gallery-8.jpg';
import imageNine from '../../images/image-gallery-9.jpg';
import imageTen from '../../images/image-gallery-10.jpg';
import imageEleven from '../../images/image-gallery-11.jpg';
import imageTwelve from '../../images/image-gallery-12.jpg';

export const galleryImages = [
	imageOne,
	imageTwo,
	imageThree,
	imageFour,
	imageFive,
	imageSix,
	imageSeven,
	imageEight,
	imageNine,
	imageTen,
	imageEleven,
	imageTwelve
];

console.log(galleryImages);
